module.exports = __webpack_public_path__ + "static/media/Artboard2.ad914506.png";